import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import Embedded from './Embedded';
import { RegionProvider } from './context/RegionContext';
import { AuthProvider } from './context/AuthContext';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

if (process.env.REACT_APP_TYPE === 'EMBEDDED') {
    root.render(
        <AuthProvider>
            <RegionProvider>
                <Embedded />
            </RegionProvider>
        </AuthProvider>
    );
} else {
    root.render(
        <AuthProvider>
            <RegionProvider>
                <App />
            </RegionProvider>
        </AuthProvider>
    );
}
